import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const AmountChartView = ({ records, startYear, endYear }) => {
  const years = [];
  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }

  const monthLabels = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0"),
  );

  const totalsByYearMonth = records.reduce((acc, item) => {
    const [yearStr, month] = String(item.month || "").split("-");
    const year = Number(yearStr);
    if (!years.includes(year) || !month) return acc;

    const key = `${year}-${month}`;
    if (!acc[key]) acc[key] = 0;
    acc[key] += item.total_amount_in_target_currency;
    return acc;
  }, {});

  const chartData = monthLabels.map((month) =>
    years.reduce(
      (acc, year) => {
        acc[year] = totalsByYearMonth[`${year}-${month}`] || 0;
        return acc;
      },
      { month },
    ),
  );

  const colors = [
    "#2563eb",
    "#16a34a",
    "#dc2626",
    "#7c3aed",
    "#ea580c",
    "#0891b2",
    "#ca8a04",
    "#4f46e5",
  ];

  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis tickFormatter={(value) => value.toLocaleString()} />
        <Tooltip formatter={(value) => Number(value).toLocaleString()} />
        <Legend />
        {years.map((year, index) => (
          <Line
            key={year}
            type="monotone"
            dataKey={String(year)}
            name={String(year)}
            stroke={colors[index % colors.length]}
            strokeWidth={2}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AmountChartView;
